/* Initialize all featured collections sliders */
document.querySelectorAll('.featured-products-slider-container').forEach((slider, index) => {
  let slideCount = parseInt(slider.dataset.slideCount);

  if (window.innerWidth < 750) {
    perView = 1;
  } else {
    perView = 4;

    if (slideCount < 4) {
      perView = slideCount;
    }
  }

  const featuredProductsSlider = new Glide(slider, {
    type: 'carousel',
    startAt: 0,
    gap: '14px',
    perView: perView
  });
  
  featuredProductsSlider.mount();
});